import { render } from "./investor.vue?vue&type=template&id=9580d90a"
import script from "./investor.vue?vue&type=script&lang=js"
export * from "./investor.vue?vue&type=script&lang=js"

import "./investor.vue?vue&type=style&index=0&id=9580d90a&lang=css"

import exportComponent from "/codebuild/output/src1941686567/src/amplify-vue-poc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__